// extracted by mini-css-extract-plugin
export default {"header":"stock_header__PMDFC","link":"stock_link__qVOTP","wrapper":"stock_wrapper__ze302","unavailable":"stock_unavailable__2W9XP"};